module.exports = __webpack_public_path__ + "images/questions/qa_bg_900471d50fcb6699476cd12ac8e3e12e.png";